module.exports = __webpack_public_path__ + "img/dia_dos_pais_controle.7419bf05.png";